/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { PureComponent, ReactComponentElement } from 'react';
import * as _ from 'lodash';

// ours
import BWCurrencyInput from 'src/bw/bw-currency-input/BW-Currency-Input';
import InfoCallout from '../callout/InfoCallout';
import { Label } from '@americanexpress/dls-react';
import MoreInfoTooltip from '../more-info-tooltip/MoreInfoTooltip';
import { SalaryInputViewModel } from 'src/types/view-models/salary-input.view.model';
import LiteralsService from 'src/services/literals/LiteralsService';
import styles from './SalaryInput.module.scss';

export default class SalaryInput extends PureComponent<SalaryInputViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            <div className="drawerSection">
                <div>
                    <div className={styles.salaryInputHeader}>
                        <Label htmlFor="income" theme={{ display: 'flex', alignItems: 'center' }}>
                            {LiteralsService.getLiteral('SalaryInput.title')}
                        </Label>
                        <MoreInfoTooltip
                            body={LiteralsService.getLiteral('SalaryInput.tooltipBody')}
                            buttonAriaLabel={LiteralsService.getLiteral('SalaryInput.title')}
                        />
                    </div>
                    <BWCurrencyInput
                        fullWidth={true}
                        id="income"
                        defaultValue={0}
                        status=""
                        value={_.get(this.props.card, 'attributes.newAnnualIncome') || 0}
                        showFractions={false}
                        onChange={(value: number) => {
                            this.props.handleChangeCardAttribute(this.props.card, value, 'newAnnualIncome');
                        }}
                    />
                </div>
                <InfoCallout text={this.props.calloutText} noMargin />
            </div>
        );
    }
}
